import React from 'react';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { FinalCTA, FinalCTAContent, FinalCTAActions } from './CTA.styles';
import { useNavigate } from 'react-router-dom';

const CTA = () => {
  const navigate = useNavigate();
  return (
    <FinalCTA>
      <FinalCTAContent>
        <p className="eyebrowHeader">Ready for a Closer Look?</p>

        <h2>Talk to Our Team About a Workplace Safety Audit</h2>

        <p>
          Contact Yoda Safety Services to discuss your workplace, your current
          safety program, and the type of audit support your organization needs.
        </p>
      </FinalCTAContent>

      <FinalCTAActions>
        <PrimaryButton
          functionName={() => navigate('/contact-us')}
          span="Contact Our Team"
        />
      </FinalCTAActions>
    </FinalCTA>
  );
};

export default CTA;
